import { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import Heading from '@/shared-components/text/components/Heading';
import SettingsHeadingContext from '@/shared-components/text/components/SettingsHeadingContext';

import SettingsMenu from './components/SettingsMenu';

import './index.css';

export default function UserSettings() {
  const location = useLocation();
  const navigate = useNavigate();
  const isExpanded = location.pathname === "/profile/settings/my-collection";
  const [heading, setHeading] = useState({ text: '', to: null, action: null });
  const [isDesktopSettings, setIsDesktopSettings] = useState(false);
  const headingContextValue = useMemo(() => ({ setHeading }), []);
  const fallbackRoute = heading.to ? heading.to : isDesktopSettings ? '/profile' : '/profile/settings';
  const defaultGoBackHandler = useGoBack(fallbackRoute);
  const checkoutReturn = location.state?.checkoutReturn;
  const goBackHandler = () => {
    if (checkoutReturn?.useHistoryBack) {
      navigate(-1);
      return;
    }

    if (checkoutReturn?.to) {
      navigate(checkoutReturn.to, { state: checkoutReturn.state });
      return;
    }

    defaultGoBackHandler();
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 701px)');
    const handleChange = () => setIsDesktopSettings(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <SettingsHeadingContext.Provider value={headingContextValue}>
      <div className={`user-settings__header ${isExpanded ? "expanded" : ""}`}>
        <BackArrowIcon className="user-settings__header-back" onClick={goBackHandler}/>
        <Heading className="user-settings__header-title">{heading.text}</Heading>
        {heading.action ? (
          <div className="user-settings__header-action">
            {heading.action}
          </div>
        ) : null}
      </div>

      <div className="user-settings__container">
        <div className="user-settings__menu">
          <SettingsMenu replace/>
        </div>
        <div className={`user-settings__content ${isExpanded ? "expanded" : ""}`}>
          <Outlet/>
        </div>
      </div>
    </SettingsHeadingContext.Provider>
  );
}
